import React, {Component} from 'react'
import {connect} from 'react-redux'
import RoleDescription from './RoleDescription'


class Role extends Component {
  constructor(props){
    super(props);
  }



  render() {
    return (
      <div className="form-group col-md-4"  key={this.props.role.value}>
          <label className="custom-control custom-checkbox">
            <input
              value={this.props.role.value}
              name={this.props.role.label}
              type="checkbox"
              className="custom-control-input"
              checked={this.props.checked}
              onChange={e => this.props.handleManageRole(e.target.value) }
            />
            <span className="custom-control-indicator" />
            <RoleDescription label={this.props.role.label} description={this.props.role.parameters}/>
          </label>
        </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(Role)
